import React, {useEffect, useState} from 'react';
import {Image} from 'antd';
import {applicationConfig} from '../../../Util/config';
import {DEFAULT_CONTAINER_HEIGHT} from '../../../Util/commonUtility';
import './style.css';

const SPONSORS_VISIBLE_COUNT = 4;

const PbssSponsorsSidebar = ({
  sponsors = [],
  containerHeight = DEFAULT_CONTAINER_HEIGHT,
}) => {
  const [shouldRender, setShouldRender] = useState(false);

  const normalizedSponsors = Array.isArray(sponsors)
    ? sponsors
        .map((item) => (typeof item === 'string' ? {name: item} : item))
        .filter((item) => item && item?.name)
    : [];

  const isOverflowing = normalizedSponsors.length > SPONSORS_VISIBLE_COUNT;

  useEffect(() => {
    const handleResize = () => setShouldRender(window.innerWidth > 1000);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderLogo = (item, index) =>
    item?.name ? (
      <div key={item?.id ?? index} className='pbss-sponsors-sidebar-card'>
        <Image
          crossOrigin='anonymous'
          preview={false}
          className='pbss-sponsors-sidebar-logo'
          src={`${applicationConfig.UPLOAD_URL}/${item?.name}`}
          alt=''
        />
      </div>
    ) : null;

  const renderList = (list) => (
    <div className='pbss-sponsors-sidebar-list'>
      {list?.map((item, i) => renderLogo(item, i))}
    </div>
  );

  const shouldShowMarquee = isOverflowing && shouldRender;

  return (
    <div className='pbss-sponsors-sidebar-wrapper col-pbss-sponsors'>
      <div
        className={`pbss-sponsors-sidebar-container ${
          shouldShowMarquee ? 'pbss-sponsors-sidebar-container--marquee' : ''
        }`}
        style={{
          height: containerHeight,
          maxHeight: containerHeight,
        }}>
        <div
          className={`pbss-sponsors-sidebar-inner ${
            !isOverflowing ? 'pbss-sponsors-sidebar-inner-static' : ''
          }`}
          style={{
            minHeight: containerHeight,
          }}>
          {!normalizedSponsors.length ? null : shouldShowMarquee ? (
            <div className='pbss-sponsors-sidebar-marquee'>
              <span>{renderList(normalizedSponsors)}</span>
              <span>{renderList(normalizedSponsors)}</span>
            </div>
          ) : (
            renderList(normalizedSponsors)
          )}
        </div>
      </div>
    </div>
  );
};

export default PbssSponsorsSidebar;
